import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { middleWareDispatch } from './redux-store/middleware';
import { rootReducer } from './redux-store/reducers/index';

export const history = createBrowserHistory();

const persistConfig = {
  key: 'wa-user',
  storage,
  whitelist: ['auth', 'id', 'selectedPortfiolio'],
  blacklist: ['sessionData']
};

interface WindowWithReduxDevTools extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
}

// Attempt to access the Redux DevTools extension compose function from the window object.
// If the extension is not present, fallback to the default Redux compose function.
const composeEnhancers = (window as WindowWithReduxDevTools).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer(connectRouter(history)));

const appliedMiddlewares = applyMiddleware(thunk, middleWareDispatch, routerMiddleware(history))

export const store = createStore(
  persistedReducer,
  process.env.NODE_ENV === "development" ? composeEnhancers(appliedMiddlewares) : appliedMiddlewares
);
// history.listen(() => {
//     document.getElementById('db-content-right')?.scrollTo(0,0);
// })
export const persistor = persistStore(store);
export default store;
